import styled from 'styled-components'
import { UnchangedUserRecord } from 'Services/apiResponseTypes'
import { spacingSM } from 'Utils/styles/spacing'
import { frostedGlass, towerGray, zirconGray } from 'Utils/styles/colors'

const TableContainer = styled.div`
  overflow-y: auto;
  border: 1px solid ${zirconGray};
  border-radius: 4px;
  max-height: calc(80vh - 450px);
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Thead = styled.thead`
  position: sticky;
  top: 0;
  background-color: ${frostedGlass};
  z-index: 1;
`

const TheadTr = styled.tr`
  box-shadow: 0 2px 2px -2px ${towerGray};
`

const Th = styled.th`
  padding: ${spacingSM};
  text-align: left;
  white-space: nowrap;
`

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${frostedGlass};
  }

  &:hover {
    background-color: ${zirconGray};
  }
`

const Td = styled.td`
  padding: ${spacingSM};
  border-bottom: 1px solid ${zirconGray};
`

const EmptyState = styled.div`
  padding: ${spacingSM};
  text-align: center;
  color: ${towerGray};
  font-style: italic;
`

type UnchangedTabProps = {
  users: UnchangedUserRecord[]
}

export const UnchangedTab = ({ users }: UnchangedTabProps) => {
  if (users.length === 0) {
    return <EmptyState>No unchanged users</EmptyState>
  }

  return (
    <TableContainer>
      <Table>
        <Thead>
          <TheadTr>
            <Th>User</Th>
            <Th>Email</Th>
            <Th>Country</Th>
          </TheadTr>
        </Thead>
        <tbody>
          {users.map((user) => (
            <Tr key={user.user_id}>
              <Td>
                {user.first_name} {user.last_name}
              </Td>
              <Td>{user.email}</Td>
              <Td>{user.country_code}</Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  )
}
